import { PriceLockup } from '@vds/type-lockups';
import React, { useCallback } from 'react';
import { Body } from '@vds/typography';
import { Toggle } from '@vds/toggles';
import PropTypes from 'prop-types';
import { withVDSManager } from '@vds/utilities';
import { Icon } from '@vds/icons';
import {
    PerkFooterWrapper,
    PerkGridContainer,
    PerkHeaderWrapper,
    PerkImageSection,
    PerkLeftSection,
    PerkRightSection,
    PerkWrapper,
    PriceWrapper,
    TextWrapper,
    ToggleWrapper,
    FooterLeftWrapper,
    FooterRightWrapper,
    PerkMainContainer,
    PerkPromoWrapper,
  } from './styles';
import { generatePerkImage } from '../../helpers';
const PerkStreamline = (props) => {
    const handleOnKeyDown = useCallback((e, item) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          item?.onClick(e);
        }
      }, []);
    console.log("Perks New Props",props);
    const bgImage = generatePerkImage(props?.backgroundImage, props.viewport);
             console.log("bgImage",bgImage);
            const oldPriceData = {
                ...props?.oldPrice,
              leadingText: props?.oldPrice?.leadingText?.children || '',
              trailingText: props?.oldPrice?.trailingText?.children || '',}
              console.log("oldprice",oldPriceData);
    return (
          <PerkGridContainer>
             <PerkMainContainer> {props?.promo && (
              <PerkPromoWrapper $gap={props?.promo.spacing} $padding={`0px 0px ${props?.promo.spacing} 0px`}>
                {props?.promo.icon && <Icon {...props?.promo.icon} />}
                <Body {...props?.promo} />
              </PerkPromoWrapper>
            )}<PerkWrapper role="button" tabIndex={0} onClick={props?.onClick} onKeyDown={(e) => handleOnKeyDown(e, item)}><PerkLeftSection>
            <PerkImageSection $bg={bgImage} />
          </PerkLeftSection>
          <PerkRightSection>
          <PerkHeaderWrapper>
          <ToggleWrapper>
          <TextWrapper>
          <Body {...props?.title} size={props.viewport === 'mobile' ? 'medium' : 'large'} />
            </TextWrapper>
            </ToggleWrapper>
          </PerkHeaderWrapper>
          <PerkFooterWrapper>
          <FooterLeftWrapper>
          {props?.newPrice && (
                      <PriceWrapper>
                        <PriceLockup {...props?.newPrice} size={props?.viewport === 'mobile' ? 'small' : 'small'} />
                      </PriceWrapper>
                    )}
            {props?.oldPrice && (
                      <PriceWrapper>
                        <PriceLockup {...oldPriceData} size={props?.viewport === 'mobile' ? 'XSmall' : 'XSmall'} kind="savings" />
                      </PriceWrapper>
                    )}         
          </FooterLeftWrapper>
          <FooterRightWrapper>
          {props?.toggle && (
                      <Toggle
                        {...props?.toggle}
                        onChange={(e, element) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                          }
                          props?.toggle.onChange(e, element);
                        }}
                        on={!!props?.toggle.on}
                      />
                    )}
          </FooterRightWrapper>
          </PerkFooterWrapper>
          </PerkRightSection>
          </PerkWrapper></PerkMainContainer>
         </PerkGridContainer>
    )
}
PerkStreamline.propTypes = {
    tiles: PropTypes.array,
    viewport: PropTypes.string,
  };
export default withVDSManager(PerkStreamline);